import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useTramite } from "../context/Tramite";
import { isInvalid } from "../utils/forms";
import "./css/components.css";
import { crearOperacionUnitaria } from "../utils/data";
import { isEditable } from "../utils/tramite";
import Loader from "./controls/Loader";
import Alert from "./controls/Alert";
import Collapsible from "./controls/Collapsible";
import ArrayField from "./controls/ArrayField";
import Grid from "./layout/Grid";
import Row from "./layout/Row";
import Col from "./layout/Col";
import { OperacionUnitariaForm } from "./OperacionUnitariaForm";
import { OperacionUnitariaList } from "./OperacionUnitariaList";
import { TipoTramite } from "../utils/enums";

export default function OperacionesUnitariasForm({ ...props }) {
  const { tramite } = useTramite();
  const { t } = useTranslation();
  const tramiteForm = useFormikContext();
  const [loading, setLoading] = useState(false);
  const handleOperacionesUnitariasChange = (event) => {
    tramiteForm.handleChange(event);
  };
  useEffect(() => {
    setLoading(!tramite);
  }, [tramite]);
  return (
    <Loader loading={loading}>
      <Alert variant="warning">
        <Collapsible summary={t("operacionesUnitariasForm.nota.resumen")}>
          <p>{t("operacionesUnitariasForm.nota.detalle")}</p>
        </Collapsible>
      </Alert>
      <ArrayField
        id="operacionesUnitarias"
        name="operacionesUnitarias"
        label={t("tramite.operacionesUnitarias")}
        value={tramiteForm.values?.operacionesUnitarias}
        onChange={handleOperacionesUnitariasChange}
        createItem={crearOperacionUnitaria}
        isInvalid={isInvalid("operacionesUnitarias", tramiteForm)}
        error={
          (tramiteForm.errors.operacionesUnitarias instanceof Array &&
            t("errors.tramite.operacionesUnitarias.many")) ||
          t(tramiteForm.errors.operacionesUnitarias)
        }
        disabled={
          !isEditable(tramite) || tramite.tipo.codigo !== TipoTramite.DJG
        }
      >
        {({
          value: operacionesUnitarias,
          selectedIndex,
          selectedItem,
          append,
          remove,
          select,
          replace,
          disabled,
        }) => (
          <Grid>
            {!disabled && (
              <Row>
                <Col lg={12}>
                  <OperacionUnitariaForm
                    value={selectedItem}
                    page={selectedIndex}
                    pages={operacionesUnitarias.length}
                    select={select}
                    append={append}
                    replace={replace}
                    remove={remove}
                    disabled={disabled}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col lg={12}>
                <OperacionUnitariaList
                  value={operacionesUnitarias}
                  select={select}
                  remove={remove}
                  disabled={disabled}
                />
              </Col>
            </Row>
          </Grid>
        )}
      </ArrayField>
    </Loader>
  );
}
